<template>
    <v-container fluid fill-height>
        <v-row
            align="center"
            justify="center"
        >
          <v-col cols="12"
           v-for="(item, index) in ItemsNews" :key="index">
            <v-card class="shadow-small round" height="100%">
              <v-card-title primary-title>{{item.title}}</v-card-title>
              <v-card-text>
                <span v-html="item.content"></span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
    </v-container>
</template>
<script>

export default {
    data: () => ({
    }),
    computed: {
      ItemsNews() {
        return this.$store.getters["news/ITEMS_NEWS"];
      },
    },
    created() {
        this.news()
    },
    methods: {
        async news() {
          try {
            await this.$store.dispatch("news/INDEX"); 
          } catch (error) {
            console.log(error);       
          }
        },
    }
};
</script>
<style>
    
</style>